"use client";

import { TimelineContainer } from "./timeline-container";
import { ExcursionItineraryInner } from "./excursion-itinerary-inner";
import { iExcursionLegDetails } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

export function ExcursionItinerary(
  props: iExcursionLegDetails & { primaryColor?: string; day: number }
) {
  return (
    <TimelineContainer
      title={props.title || "Excursion"}
      icon={(props.icon as any) || "activity"}
    >
      <ExcursionItineraryInner {...props} day={props.day} />
    </TimelineContainer>
  );
}
